import axios from 'axios';
import { useMutation } from 'react-query';

export type CancelMigrationFromContentApiResponse = {
  code: string;
  message: string;
};

const cancelMigrationFromContentApi = async (
  merchantId: string,
): Promise<CancelMigrationFromContentApiResponse> => {
  const { data } = await axios.post(
    `/api/merchants/${merchantId}/cancel-migration-from-content-api`,
  );
  return data;
};

export const useCancelMigrationFromContentApi = ({ onSuccess, onError }) => {
  return useMutation(cancelMigrationFromContentApi, {
    onSuccess,
    onError,
  });
};
